import React, { PureComponent } from 'react';
import { Flex, Box } from 'reflexbox';
import { connect } from 'unistore/react';

import Icon from '~/core/scripts/components/Icon';

import './AnalysisTeaser.styl';

class AnalysisTeaser extends PureComponent {
  render() {
    if (this.props.isBeforeElection) {
      return null;
    }

    return (
      <div className="analysis-teaser">
        <div className="analysis-teaser__text">
          <a href="" className="analysis-teaser__link">
            <span className="analysis-teaser__title">Analyse der Europawahl 2019</span>
            <span className="analysis-teaser__desc">Hier ist ein Link zur anderen Geschichte</span>
          </a>
        </div>
        <Flex justify="center" align="center" className="analysis-teaser__icon">
          <Icon type="stats" />
        </Flex>
      </div>
    );
  }
}

export default connect('isBeforeElection')(AnalysisTeaser);
